module.exports = __webpack_public_path__ + "static/media/azteca.497d9f82.png";